// extracted by mini-css-extract-plugin
export default {"row":"createLeaderboard_row__4juMI","col":"createLeaderboard_col__qwvWP","card":"createLeaderboard_card__7GDED"};